import styled from "styled-components";

export const DateLayout = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const DateText = styled.header`
  font-family: "Noto Sans KR";
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  flex-shrink: 0;
  width: 219px;
  display: flex;
  justify-content: flex-end;
  // margin-left: 930px;
  margin-bottom: 14px;
  line-height: 140%; /* 44.8px */
`;
